(function () {
  const drawerSelector = 'cart-drawer';
  const drawerFormSelector = '#CartDrawer-Form';
  const changeTimers = new WeakMap();

  function getDrawer() {
    const drawer = document.querySelector(drawerSelector);
    attachDrawerMethods(drawer);
    return drawer;
  }

  function getFocusableElements(container) {
    if (!container) return [];
    return Array.from(
      container.querySelectorAll(
        'summary, a[href], button:enabled, [tabindex]:not([tabindex^="-"]), input:not([type=hidden]):enabled, select:enabled, textarea:enabled'
      )
    );
  }

  function trapFocusFallback(container, elementToFocus) {
    if (typeof window.trapFocus === 'function') {
      window.trapFocus(container, elementToFocus || container);
      return;
    }
    const focusTarget = elementToFocus || getFocusableElements(container)[0];
    if (focusTarget) focusTarget.focus();
  }

  function removeTrapFocusFallback(elementToFocus) {
    if (typeof window.removeTrapFocus === 'function') {
      window.removeTrapFocus(elementToFocus);
      return;
    }
    if (elementToFocus) elementToFocus.focus();
  }

  function openDrawer(drawer, triggeredBy) {
    if (!drawer) return;
    if (triggeredBy) drawer.activeElement = triggeredBy;
    drawer.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');

    const focusContainer = drawer.classList.contains('is-empty')
      ? drawer.querySelector('.drawer__inner-empty')
      : drawer.querySelector('#CartDrawer');
    const focusElement = drawer.querySelector('.drawer__inner') || drawer.querySelector('.drawer__close');
    if (focusContainer && focusElement) {
      setTimeout(function () {
        trapFocusFallback(focusContainer, focusElement);
      }, 0);
    }
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('active');
    removeTrapFocusFallback(drawer.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  function getSectionInnerHTML(html, selector) {
    if (!html) return null;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const source = selector ? doc.querySelector(selector) : doc.body;
    return source ? source.innerHTML : null;
  }

  function getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  function renderSections(parsedState) {
    if (!parsedState || !parsedState.sections) return;

    getSectionsToRender().forEach(function (section) {
      const sectionHtml = parsedState.sections[section.section];
      const targetRoot = document.getElementById(section.id);
      if (!sectionHtml || !targetRoot) return;

      const target = section.selector ? targetRoot.querySelector(section.selector) || targetRoot : targetRoot;
      const nextHtml = getSectionInnerHTML(sectionHtml, section.selector);
      if (target && nextHtml !== null) target.innerHTML = nextHtml;
    });

    const drawer = getDrawer();
    if (drawer) drawer.classList.toggle('is-empty', parsedState.item_count === 0);
  }

  function attachDrawerMethods(drawer) {
    if (!drawer || drawer.dataset.ajaxQuantityFixReady === 'true') return;
    drawer.dataset.ajaxQuantityFixReady = 'true';

    if (typeof drawer.open !== 'function') {
      drawer.open = function (triggeredBy) {
        openDrawer(drawer, triggeredBy);
      };
    }

    if (typeof drawer.close !== 'function') {
      drawer.close = function () {
        closeDrawer(drawer);
      };
    }

    if (typeof drawer.renderContents !== 'function') {
      drawer.renderContents = function (parsedState) {
        renderSections(parsedState);
        setTimeout(function () {
          openDrawer(drawer);
        }, 0);
      };
    }
  }

  function fetchConfig() {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };
  }

  function cartChangeUrl() {
    if (window.routes && window.routes.cart_change_url) return window.routes.cart_change_url;
    return '/cart/change.js';
  }

  function normalizeQuantity(input) {
    let quantity = parseInt(input.value, 10);
    if (Number.isNaN(quantity)) quantity = parseInt(input.getAttribute('value') || '1', 10);
    if (Number.isNaN(quantity)) quantity = 1;

    const min = input.min !== '' ? parseInt(input.min, 10) : null;
    const max = input.max !== '' ? parseInt(input.max, 10) : null;

    if (min !== null && !Number.isNaN(min) && quantity < min) quantity = min;
    if (max !== null && !Number.isNaN(max) && quantity > max) quantity = max;

    input.value = quantity;
    return quantity;
  }

  function setLoading(line, loading) {
    const cartItems = document.getElementById('CartDrawer-CartItems');
    if (cartItems) cartItems.classList.toggle('cart__items--disabled', loading);

    document
      .querySelectorAll('#CartDrawer-Item-' + line + ' .loading-overlay')
      .forEach(function (overlay) {
        overlay.classList.toggle('hidden', !loading);
      });

    const status = document.getElementById('CartDrawer-LineItemStatus');
    if (status) status.setAttribute('aria-hidden', loading ? 'false' : 'true');
  }

  function updateLiveRegion(line, message) {
    const lineItemError = document.getElementById('CartDrawer-LineItemError-' + line);
    if (lineItemError) {
      const errorText = lineItemError.querySelector('.cart-item__error-text');
      if (errorText) errorText.innerHTML = message || '';
    }

    const cartStatus = document.getElementById('CartDrawer-LiveRegionText');
    if (!cartStatus) return;
    cartStatus.setAttribute('aria-hidden', 'false');
    setTimeout(function () {
      cartStatus.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  function focusAfterRender(line, name) {
    const drawer = getDrawer();
    if (!drawer) return;

    const lineItem = document.getElementById('CartDrawer-Item-' + line);
    const focusTarget = lineItem && name
      ? lineItem.querySelector('[name="' + name + '"]')
      : lineItem && lineItem.querySelector('.quantity__input');

    if (focusTarget) {
      trapFocusFallback(drawer, focusTarget);
      return;
    }

    if (drawer.classList.contains('is-empty')) {
      const emptyFocus = drawer.querySelector('.drawer__inner-empty a, .drawer__inner-empty button');
      if (emptyFocus) trapFocusFallback(drawer.querySelector('.drawer__inner-empty'), emptyFocus);
      return;
    }

    const firstItemLink = drawer.querySelector('.cart-item__name');
    if (firstItemLink) trapFocusFallback(drawer, firstItemLink);
  }

  async function updateQuantity(line, quantity, name, input) {
    if (!line) return;
    const previousValue = input ? input.getAttribute('value') || input.defaultValue || input.value : quantity;

    setLoading(line, true);

    try {
      const body = JSON.stringify({
        line: String(line),
        quantity: Number(quantity),
        sections: getSectionsToRender().map(function (section) {
          return section.section;
        }),
        sections_url: window.location.pathname,
      });

      const response = await fetch(cartChangeUrl(), Object.assign(fetchConfig(), { body: body }));
      const parsedState = await response.json();

      if (parsedState.errors) {
        if (input) input.value = previousValue;
        updateLiveRegion(line, parsedState.errors);
        return;
      }

      renderSections(parsedState);
      openDrawer(getDrawer());

      const nextInput = document.getElementById('Drawer-quantity-' + line);
      const updatedValue = parsedState.items && parsedState.items[line - 1]
        ? parsedState.items[line - 1].quantity
        : undefined;

      let message = '';
      if (nextInput && updatedValue !== undefined && updatedValue !== parseInt(nextInput.value, 10)) {
        message = window.cartStrings && window.cartStrings.quantityError
          ? window.cartStrings.quantityError.replace('[quantity]', updatedValue)
          : '';
      }
      updateLiveRegion(line, message);

      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-quantity-fix' });
      }

      focusAfterRender(line, name);
    } catch (error) {
      const errors = document.getElementById('CartDrawer-CartErrors');
      if (errors) {
        errors.textContent = window.cartStrings && window.cartStrings.error
          ? window.cartStrings.error
          : 'There was an error while updating your cart.';
      }
    } finally {
      setLoading(line, false);
    }
  }

  function scheduleInputUpdate(input, name) {
    if (!input) return;
    const line = input.dataset.index;
    const quantity = normalizeQuantity(input);

    if (changeTimers.has(input)) clearTimeout(changeTimers.get(input));
    changeTimers.set(
      input,
      setTimeout(function () {
        updateQuantity(line, quantity, name, input);
      }, 250)
    );
  }

  function quantityInputFromButton(button) {
    const container = button.closest('quantity-input, .quantity, .cart-item__quantity-wrapper');
    return container ? container.querySelector('.quantity__input') : null;
  }

  function handleQuantityButtonClick(event) {
    const button = event.target.closest('#CartDrawer .quantity__button');
    if (!button) return;

    const input = quantityInputFromButton(button);
    if (!input) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const previousValue = input.value;
    if (button.name === 'plus') {
      input.stepUp();
    } else {
      input.stepDown();
    }

    if (input.value !== previousValue) scheduleInputUpdate(input, button.name);
  }

  function handleQuantityInputChange(event) {
    const input = event.target.closest('#CartDrawer .quantity__input');
    if (!input) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    scheduleInputUpdate(input, document.activeElement ? document.activeElement.getAttribute('name') : null);
  }

  function handleRemoveClick(event) {
    const removeButton = event.target.closest('#CartDrawer cart-remove-button');
    if (!removeButton || !removeButton.dataset.index) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    updateQuantity(removeButton.dataset.index, 0, null, null);
  }

  function handleDrawerFormSubmit(event) {
    const form = event.target.closest(drawerFormSelector);
    if (!form) return;

    const submitter = event.submitter || document.activeElement;
    if (submitter && submitter.getAttribute('name') === 'checkout') return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const focusedInput = form.querySelector('.quantity__input:focus');
    if (focusedInput) scheduleInputUpdate(focusedInput, null);
  }

  function handleCartIconClick(event) {
    const cartLink = event.target.closest('#cart-icon-bubble');
    if (!cartLink) return;

    const drawer = getDrawer();
    if (!drawer) return;

    event.preventDefault();
    openDrawer(drawer, cartLink);
  }

  function handleOverlayClick(event) {
    if (!event.target.closest('#CartDrawer-Overlay')) return;
    closeDrawer(getDrawer());
  }

  function defineQuantityInputFallback() {
    if (customElements.get('quantity-input')) return;

    customElements.define(
      'quantity-input',
      class QuantityInputFallback extends HTMLElement {
        constructor() {
          super();
          this.input = this.querySelector('input');
          this.changeEvent = new Event('change', { bubbles: true });
          this.querySelectorAll('button').forEach(
            function (button) {
              button.addEventListener('click', this.onButtonClick.bind(this));
            }.bind(this)
          );
        }

        onButtonClick(event) {
          event.preventDefault();
          const previousValue = this.input.value;
          if (event.currentTarget.name === 'plus') this.input.stepUp();
          else this.input.stepDown();
          if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
        }
      }
    );
  }

  function defineCartDrawerFallback() {
    if (customElements.get('cart-drawer')) return;

    customElements.define(
      'cart-drawer',
      class CartDrawerFallback extends HTMLElement {
        connectedCallback() {
          attachDrawerMethods(this);
          this.addEventListener('keyup', function (event) {
            if (event.code === 'Escape') closeDrawer(this);
          });
        }
      }
    );
  }

  function init() {
    defineQuantityInputFallback();
    defineCartDrawerFallback();
    attachDrawerMethods(document.querySelector(drawerSelector));

    document.addEventListener('click', handleQuantityButtonClick, true);
    document.addEventListener('change', handleQuantityInputChange, true);
    document.addEventListener('click', handleRemoveClick, true);
    document.addEventListener('submit', handleDrawerFormSubmit, true);
    document.addEventListener('click', handleCartIconClick);
    document.addEventListener('click', handleOverlayClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
